<template>
  <NavBar pageName="ClientDetails"></NavBar>
  <v-app>
    <v-container>
      <!-- Menu wrapper -->
      <v-menu
          v-model="menu"
          :close-on-content-click="false"
          offset-y
          min-width="290px"
      >
        <!-- Activator slot -->
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              v-model="formattedDate"
              label="Due date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>

        <!-- Date Picker -->
        <v-date-picker
            v-model="due"
            @input="updateDate"
            @change="menu = false"
        ></v-date-picker>
      </v-menu>
    </v-container>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  components: {NavBar},
  data() {
    return {
      menu: false, // Controls the visibility of the menu
      due: null, // Selected date from date picker
      formattedDate: '', // Displayed formatted date
    };
  },
  methods: {
    updateDate(value) {
      // Format the date to a readable string
      this.formattedDate = value;
    },
  },
};
</script>

<style>
/* Add custom styles if needed */
</style>
